<template>
    <div class="login">
        <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8" align-v="center">
                    <div class="card">
                        <div class="card-head">
                            <div class="row">
                                <div class="col-md-6 col-12 primes text-center">
                                     <div style="margin-top:60%" >
                                    <div >
                                       <h4 class="text-white"> <b>Shipserv Ltd Triq Patri Tedeo Schembri ZABBAR ZBR2691 MALTA</b> </h4> 
                                    </div>
                                    <div>
                                      <h5 class="text-white">Tax Number: MT 2184 7134</h5> 
                                    </div>
                                    </div>
                                    <!-- <img src="../assets/img/oneshot.png" width="100%" class="logo" alt=""> -->
                                </div>
                                <div class="col-md-6 col-12 text-center px-5">
                                    <h2 class="heading" style="margin-top:130px !important">New Account</h2>
                                    <form class="mt-3">
                                        <input type="text" v-model="register.username" placeholder="Username" class="form-control">
                                        <input type="email" v-model="register.email" placeholder="Email" class="form-control mt-3">
                                        <input type="password" v-model="register.password" placeholder="Password" class="form-control mt-3">
                                        <input type="number" v-model="register.contact1" placeholder="Contact Number" class="form-control mt-3">
                                        <input type="text" v-model="register.vesselname" placeholder="Company Name / Vessel" class="form-control mt-3">
                                        <b-textarea rows="2" type="text" v-model="register.address" placeholder="Address" class="form-control mt-3"/>

                                        <b-button variant="primary" class="mt-3" block @click="createAccount">Create</b-button>
                                        <div><sub>Have an account login<router-link to="/"> Login Here</router-link> </sub></div>
                                        <div><sub>Reset your password <router-link to="/reset-password">Click Here</router-link> </sub></div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import {mapGetters} from 'vuex'
export default {
    name: "Login",
    computed:{
        ...mapGetters(['autoids']),
        onlyfields(){
            console.log(typeof(this.register['showid']))
            return Object.keys(this.register).filter(item=> typeof(this.register[item])!='boolean')
        },
        validationChecker(){
           return this.onlyfields.filter(item=>this.register[item]=='')
        },
    },
    methods: {

        createAccount() {
        if(this.validationChecker.length<1) {
            this.register.created=moment().format('YYYY-MM-DD')
            this.register.showid=this.autoids.users+1
            this.$store.dispatch("updateAutoId",{users:this.autoids.users+1})
        
                
            this.$store.dispatch("createUser",this.register)
                this.register={
                    email:'',
                    password:'',
                    vesselname:'',
                    contact1:'',
                    username:'',
                    address:''
                }
            }
            else{
                this.$store.commit("setNotifications",{message:'Fill in all fields',type:'error'})

            }

        },

    },
    data(){
        return {
            
            register:{
            email:'',
            password:'',
            vesselname:'',
            contact1:'',
            address:'',
            isadmin:false,
            showprices:'none',
            showid:'0',
            created:moment().format('YYYY-MM-DD')
            }
        }
    }
}
</script>

<style scoped>

.login {
        /* background: #d7dfe1; */
        min-height: 100vh;
        padding-top: 40px;
    }
    .primes {
        background: #5580fe;
        height: 710px !important;
    }
    .logo {
        margin-top: 70%;
    }
    
    p {
        font-size: 14px;
        margin-top: 10px;
    }
    .log:hover {
        cursor: pointer;
    }
    h2 {
        margin-top: 70%;
    }
    @media screen and (max-width: 567px) {
        .login {
            padding-top: 0px;
        }
        h2 {
            margin-top: 10%;
        }
    }
</style>